import React, { useEffect, useState } from "react";
import {
	Box,
	Image,
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalFooter,
	ModalBody,
	ModalCloseButton,
	useDisclosure,
	Button,
	Text,
	useToast,
} from "@chakra-ui/react";
import { Raider } from "../../../types/raider";
import { nameCleanup } from "../../../util/helpers";
import {
	addMount,
	approveMounts,
	areMountsApproved,
} from "../../../util/web3/interactMounts";
import { Mount } from "../../../types/mount";

interface MountProps {
	raider: Raider;
	mount: Mount;
}

export default function MountPanel(props: MountProps) {
	const { mount, raider } = props;
	const { isOpen, onOpen, onClose } = useDisclosure();
	const [speed, setSpeed] = useState<number>();

	const toast = useToast();

	const mountingHandler = async () => {
		if (!process.env.NEXT_PUBLIC_ADD_MOUNT) {
			throw "missing questing env.";
		}
		const approval = await areMountsApproved();

		if (!approval) {
			await approveMounts(toast);
		} else if (approval) {
			addMount(parseInt(raider.id), Number(mount.id), toast);
			onClose();
		}
	};

	useEffect(() => {
		const speedFixer = () => {
			const wrongSpeed = mount.attributes[3].value;
			if (wrongSpeed == 100) {
				setSpeed(50);
			} else if (wrongSpeed == 150) {
				setSpeed(150);
			}
		};

		speedFixer();
	}, [mount.attributes]);

	return (
		<>
			<Box>
				<Image
					src={mount.image}
					alt={mount.name}
					onClick={onOpen}
					cursor="pointer"
				/>
			</Box>
			<Modal isOpen={isOpen} onClose={onClose}>
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>Equip {mount.name}?</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Text mb="10px">
							{nameCleanup(raider.name)} will receive a {speed}% speed boost for
							gathering items on quests and returning home.
						</Text>
						<Text mb="10px">
							This boost will persist through all quests until you dismount.
						</Text>
						<Text mb="10px">
							While mounted, your Mount will not be tradeable.
						</Text>
					</ModalBody>

					<ModalFooter>
						<Button colorScheme="blue" mr={3} onClick={() => mountingHandler()}>
							Mount Up!
						</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
		</>
	);
}
